import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/asset-landing/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/asset-landing/Hero/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/asset-landing/SupportedAssets/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Testimonials"] */ "/vercel/path0/components/asset-landing/Testimonial/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/vercel/path0/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
